import { faCog } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../reducers/LocaleReducer/LocalReducer'

const Loading = ({ children, loading, size, style }) => {
  const t = useSelector(selectTranslate)

  return (
    <>
      {loading && (
        <div className='loading-container' style={style ?? {}}>
          <FontAwesomeIcon icon={faCog} spin size={size ?? '1x'} />
          <b>
            {t('common.loading')}
          </b>
        </div>
      )}
      {!loading && (
        <>
          {children}
        </>
      )}
    </>
  )
}

export default Loading
